// Open / close the geo drawer (desktop) or modal (mobile), CSS handles the transition
function toggleModal(open) {
  document.querySelectorAll(".popup-geolocation, .popup-overlay").forEach((el) => {
    el.classList.toggle("is-open", open);
  });
}

function closeModal() {
  toggleModal(false);
}

document.querySelectorAll(".popup-button").forEach((button) => {
  button.addEventListener("click", () => toggleModal(true));
});

document.querySelectorAll(".popup-overlay").forEach((overlay) => {
  overlay.addEventListener("click", closeModal);
});

// Point every country link (desktop drawer + mobile menu) at the same path on the other store
function setLinks() {
  const elements = document.querySelectorAll("a[data-country]");
  const pathname = window.location.pathname;

  elements.forEach((element) => {
    const country = element.getAttribute("data-country");
    let href;

    switch (country) {
      case 'dk':
        href = "https://otay.dk" + pathname;
        break;
      case 'no':
        href = "https://otay.no" + pathname;
        break;
      case 'eu':
        href = "https://otay.eu" + pathname;
        break;
      default:
        // Handle unrecognized country
        href = "#";
        break;
    }
    element.href = href;
  });
}

// Auto-open once per browser when not on the DK store
function showCountry() {
  if (window.location.hostname === "otay.dk") return;

  const hasShownPopup = localStorage.getItem("MERCIVE_GeolocationSwitch_hasShownPopup");
  if (hasShownPopup !== null) return;

  localStorage.setItem("MERCIVE_GeolocationSwitch_hasShownPopup", true);
  toggleModal(true);
}

showCountry();
setLinks();
